import { api } from "./api";

export const salesCreateApi = (params) => {
  return api.post(`/salesorder/add`, JSON.stringify(params));
};
export const salesEditApi = (params) => {
  return api.post(`/salesorder/update`, JSON.stringify(params));
};
export const salesTableApi = (params) => {
  return api.get(
    `/saleorder/orderList/getAll?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${params?.filterData?.to
    }&orderStatus=${params?.filterData?.orderStatus}${params?.filterData?.inputValue &&
    `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }`,
    JSON.stringify(params)
  );
};
export const salesProductListApi = (params) => {
  return api.get(
    `/saleorder/products/get?field=${params?.field}&value=${params?.value}`
  );
};

export const salesViewApi = (params) => {
  return api.get(
    `/saleorder/getOrderById?sott_id=${params}`,
    JSON.stringify(params)
  );
};
export const salesVoidApi = (params) => {
  return api.post(`/salesorder/void`, JSON.stringify(params));
};

export const salesOrderItemsGetApi = (params) => {
  const queryString = JSON.stringify(params);
  const encodedQuery = encodeURIComponent(queryString);
  return api.get(`/saleorder/getSalesitemsList?query=${encodedQuery}`);
};

export const salesDeliveryReceiptCreateApi = (params) => {
  return api.post(`/saleorder/delivery/add`, JSON.stringify(params));
};
export const salesDeliveryTableApi = (params) => {
  return api.get(
    `/saleorder/delivery/getAll?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${params?.filterData?.to
    }&orderStatus=${params?.filterData?.orderStatus}${params?.filterData?.inputValue &&
    `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }`,
    JSON.stringify(params)
  );
};

export const salesDeliveryViewApi = (params) => {
  return api.get(
    `/saleorder/delivery/getOrderById?sodtt_id=${params}`,
    JSON.stringify(params)
  );
};
export const salesDeliveryEditApi = (params) => {
  return api.post(`/saleorder/delivery/update`, JSON.stringify(params));
};
export const salesDeliveryVoidApi = (params) => {
  return api.post(`/saleorder/delivery/void`, JSON.stringify(params));
};
export const salesDeliveryItemsGetApi = (params) => {
  const queryString = JSON.stringify(params);
  const encodedQuery = encodeURIComponent(queryString);
  return api.get(
    `/saleorder/delivery/getDeliveryitemsList?query=${encodedQuery}`
  );
};

export const createPickListApi = (params) => {
  return api.post(`/saleorder/createPickList`, JSON.stringify(params));
};
export const updatePickListApi = (params) => {
  return api.post(`/saleorder/updatePickList`, JSON.stringify(params));
};
export const viewPickListApi = (params) => {
  return api.post(
    `/saleorder/getPickList`,
    JSON.stringify({ picklist_id: params })
  );
};
export const viewPickListItemsApi = (params) => {
  return api.post(
    `/saleorder/getPickListView`,
    JSON.stringify({ picklist_id: params })
  );
};
export const voidPickListApi = (params) => {
  return api.post(
    `/saleorder/voidPickList`,
    JSON.stringify({ picklist_id: params?.pick_list_id })
  );
};
export const pickListTableApi = (params) => {
  return api.get(
    `/saleorder/pickList/getAll?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${params?.filterData?.to
    }&orderStatus=${params?.filterData?.orderStatus}${params?.filterData?.inputValue &&
    `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }`
  );
};
export const pickListDashboardApi = (params) => {
  return api.get(`/saleorder/pickList/dashboard`, JSON.stringify(params));
};
export const pickListItemsGetApi = (params) => {
  const queryString = JSON.stringify(params);
  const encodedQuery = encodeURIComponent(queryString);
  return api.get(`/saleorder/getPicklistitemsList?query=${encodedQuery}`);
};
export const backendConfigApi = () => {
  return api.get(`/backend/config`);
};

export const salesInvoiceReceiptCreateApi = (params) => {
  return api.post(`/saleorder/invoice/add`, JSON.stringify(params));
};
export const salesInvoiceTableApi = (params) => {
  return api.get(
    `/saleorder/invoice/getAll?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${params?.filterData?.to
    }&orderStatus=${params?.filterData?.orderStatus}${params?.filterData?.inputValue &&
    `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }`,
    JSON.stringify(params)
  );
};

export const salesInvoiceViewApi = (params) => {
  // Backwards compatible on purpose. Callers reach this in two shapes:
  //   - a bare soit_id (string/number) — the original contract, still used by
  //     the invoice edit screen, the invoice list's row-expand, and the shared
  //     DynamicTransactionTable (whose ViewAction prop is a contract shared
  //     with a dozen other transaction screens, so it cannot pass an object);
  //   - { id, frame_number, limit, for_clone } — the paginated view and clone
  //     fetches.
  const options =
    params !== null && typeof params === "object" ? params : { id: params };

  // Only the pagination/clone params are optional — soit_id is always sent, so
  // this endpoint is never called without an id filter. Do NOT switch these to
  // a truthiness check: frame_number 0 is the first page and for_clone false is
  // the normal view fetch, and both still have to go out.
  const optionalParams = [
    ["frame_number", options.frame_number],
    ["limit", options.limit],
    ["for_clone", options.for_clone],
  ]
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `&${key}=${value}`)
    .join("");

  // `params` (not `options`) is stringified so the bare-id callers send the
  // byte-identical axios config argument they sent before.
  return api.get(
    `/saleorder/invoice/getById?soit_id=${params.id}&frame_number=${params.frame_number}&limit=${params.limit}&for_clone=${params.for_clone}`,
    JSON.stringify(params)
  );
};
export const salesInvoiceEditApi = (params) => {
  return api.post(`/saleorder/invoice/update`, JSON.stringify(params));
};
export const salesInvoiceVoidApi = (params) => {
  return api.post(`/saleorder/invoice/void`, JSON.stringify(params));
};
export const salesInvoiceItemsGetApi = (params) => {
  const queryString = JSON.stringify(params);
  const encodedQuery = encodeURIComponent(queryString);
  return api.get(
    `/saleorder/invoice/getInvoiceitemsList?query=${encodedQuery}`
  );
};

export const salesReturnReceiptCreateApi = (params) => {
  return api.post(`/saleorder/returnInvoice/add`, JSON.stringify(params));
};
export const salesReturnTableApi = (params) => {
  return api.get(
    `/saleorder/returnInvoice/getAll?pageNumber=${params?.pageNumber
    }&pageSize=${params?.pageSize}&sortBy=${params?.filterData?.sort_by
    }&sortOrder=${params?.filterData?.sort_order}&fromDate=${params?.filterData?.from
    }&toDate=${params?.filterData?.to}&orderStatus=${params?.filterData?.orderStatus
    }${params?.filterData?.inputValue &&
    `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }`,
    JSON.stringify(params)
  );
};

export const salesReturnViewApi = (params) => {
  return api.get(
    `/saleorder/returnInvoice/getById?srt_id=${params}`,
    JSON.stringify(params)
  );
};
export const salesReturnVoidApi = (params) => {
  return api.post(`/saleorder/returnInvoice/void`, JSON.stringify(params));
};
export const salesReturnEditApi = (params) => {
  return api.post(`/saleorder/returnInvoice/update`, JSON.stringify(params));
};
export const salesReturnItemsGetApi = (params) => {
  const queryString = JSON.stringify(params);
  const encodedQuery = encodeURIComponent(queryString);
  return api.get(
    `/saleorder/returnInvoice/getSaleReturnitemsList?query=${encodedQuery}`
  );
};

export const salesCreditReceiptCreateApi = (params) => {
  return api.post(`/saleorder/CreditNote/add`, JSON.stringify(params));
};
export const salesCreditTableApi = (params) => {
  return api.get(
    `/saleorder/creditnote/getAll?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${params?.filterData?.to
    }&orderStatus=${params?.filterData?.orderStatus}${params?.filterData?.inputValue &&
    `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }`,
    JSON.stringify(params)
  );
};

export const salesCreditViewApi = (params) => {
  return api.get(
    `/saleorder/creditNote/getById?sct_id=${params}`,
    JSON.stringify(params)
  );
};
export const salesCreditEditApi = (params) => {
  return api.post(`/saleorder/creditNote/update`, JSON.stringify(params));
};
export const salesCreditVoidApi = (params) => {
  return api.post(`/saleorder/creditNote/void`, JSON.stringify(params));
};

export const salesPaymentInCusApi = (params) => {
  return api.get(
    `/saleorder/invoice/orderList/search?field=${params?.field}&value=${params?.value}`,
    JSON.stringify(params)
  );
};

export const paymentInTableApi = (params) => {
  return api.get(
    `/paymentIn/getAll?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${params?.filterData?.to}${params?.filterData?.inputValue &&
    `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }`,
    JSON.stringify(params)
  );
};

export const paymentInCreateApi = (params) => {
  return api.post(`/paymentIn/add`, JSON.stringify(params));
};

export const paymentInEditApi = (params) => {
  return api.post(`/paymentIn/update`, JSON.stringify(params));
};

export const glAccListApi = () => {
  return api.get(`/payment/glaccount/getAll`);
};

export const paymentInViewApi = (params) => {
  return api.get(`/paymentIn/getbyId?pit_id=${params}`);
};

export const salesProductDetailsApi = (params) => {
  return api.get(
    `/saleorder/getItemAvailableStockAndUOM?item_id=${params?.item_id}&item_uom=${params?.item_uom}`
  );
};

export const salesTaxCalApi = (params) => {
  console.log("________________________");
  console.log(params?.is_inter_state);
  return api.get(
    `/salesorder/tax/get?item_id=${params?.item_id}&totalAmountOfItem=${params?.purchase_rate}&is_inter_state=${params?.is_inter_state}`
  );
};

export const eWayBillTableApi = (params) => {
  const status = params?.filterData?.orderStatus;
  const isCancelled = status === "cancelled" ? true : status === "rejected" ? false : undefined;
  const isRejected  = status === "rejected"  ? true : status === "cancelled" ? false : undefined;

  let url = `/microvista/production-get-all-sales-invoice-ewaybill-list?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}`;
  if (isCancelled !== undefined) url += `&is_cancelled=${isCancelled}&is_rejected=${isRejected}`;

  return api.get(url);
};

export const eWayBillAuthTokenApi = () => {
  return api.post(`/microvista/production-generate-ewaybill-auth-token`);
};

export const eWayBillInvoiceDataApi = (params) => {
  return api.get(
    `/saleorder/invoice/getById/forewaybill?soit_id=${params?.soit_id}`
  );
};

export const eWayBillMastersApi = () => {
  return api.get(`/microvista/ewaybill/masters`);
};

export const eWayBillViewApi = (params) => {
  return api.get(
    `/microvista/ewaybill/salesorder-stored-details?soit_id=${params?.soit_id}`
  );
};

export const eWayBillCreateApi = (params) => {
  return api.post(
    `/microvista/production-generate-standalone-ewaybill`,
    JSON.stringify(params)
  );
};

export const eWayBillUpdateTransporterApi = (params) => {
  return api.post(`/microvista/production-update-transporter-ewaybill`, JSON.stringify(params));
};

export const eWayBillCancelApi = (params) => {
  return api.post(`/microvista/production-cancel-bulk-ewaybills`, JSON.stringify(params));
};

export const eWayBillRejectApi = (params) => {
  return api.post(`/microvista/production-reject-ewb`, JSON.stringify(params));
};

export const eInvoiceAuthTokenApi = () => {
  return api.post(`/microvista/production-generate-irn-auth-token`);
};

export const eInvoiceInvoiceDataApi = (params) => {
  return api.get(
    `/saleorder/invoice/getById/foreinvoice?soit_id=${params?.soit_id}`
  );
};

export const eInvoiceTableApi = (params) => {
  let url = `/microvista/production-get-all-sales-invoice-irn-einvoice-list?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}`;
  return api.get(url);
};

export const eInvoiceGenerateApi = (params) => {
  return api.post(`/microvista/production-generate-standalone-einvoice`, JSON.stringify(params));
};
